// extracted by mini-css-extract-plugin
export default {"container":"TableResults_container__MXDu5"};